// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"5d39c4af","455":"95fb9b09","488":"9cf65ea5","952":"86c48b42","977":"05f581b9"}[chunkId] + ".chunk.js";
};